<template>
  <div class="row">
    <div class="col-12">
      <c-table
        ref="tableImpr"
        title="개선 목록"
        tableId="impr01"
        :columns="gridImpr.columns"
        :data="gridImpr.data"
        :merge="gridImpr.merge"
        :gridHeight="setheight"
        @linkClick="linkClick"
      >
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
export default {
  name: 'hazop-impr',
  props: {
    param: {
      type: Object,
      default: function() {
        return {
          disabled: false,
        }
      },
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      gridImpr: {
        merge: [
          { index: 0, colName: 'col11' },
          { index: 1, colName: 'col12' },
        ],
        columns: [
          {
            name: 'col11',
            field: 'col11',
            label: '감사대상',
            align: 'left',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'col12',
            field: 'col12',
            label: '감사항목',
            align: 'left',
            style: 'width:400px',
            sortable: false,
          },
          {
            name: 'col13',
            field: 'col13',
            label: '개선요청제목',
            align: 'left',
            type: 'link',
            style: 'width:250px',
            sortable: true,
          },
          {
            name: 'col5',
            field: 'col5',
            label: '진행상태',
            align: 'center',
            style: 'width:100px',
            type: 'tag',
            colorItems: [
              { value: '요청', color: 'amber' },
              { value: '접수', color: 'lime' },
              { value: '조치중', color: 'light-green' },
              { value: '검토', color: 'teal' },
              { value: '완료', color: 'blue' },
            ],
            sortable: false
          },
          {
            name: 'col1',
            field: 'col1',
            label: '요청부서정보',
            align: 'center',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '조치기한',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '조치부서',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ],
        data: [],
        height: '500px'
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        param: {},
        closeCallback: null,
      },
      editable: true,
      searchUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    setheight() {
      let pxRemove = this.height.replace('px', '');
      return this.height && this.height.indexOf('px') > -1 && !isNaN(pxRemove) ? (Number(pxRemove) - 50) + 'px' : '500px'
    }
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.gridImpr.data = [
        {
          col11: '안전경영과 근로자참여',
          col12: '1-01 사업장에서 사용하고 있는 유해위험물질의 목록이 누락된 물질 없이 정확히 작성되어 있는가?',
          col13: '개선요청제목1',
          col1: '안전환경팀/시스템/2021-06-24',
          col2: '2021-07-24',
          col3: '기술팀',
          col4: '2021-06-24 hazop xx작업내용에 대한 개선요청',
          col5: '접수',
        },
        {
          col11: '안전경영과 근로자참여',
          col12: '1-02 사업장에서 사용하고 있는 유해·위험물질에 대한 물질안전보건자료(MSDS)의 작성, 비치, 교육, 경고표지 등이 적절하게 되었는가?',
          col13: '개선요청제목2',
          col1: '안전환경팀/시스템/2021-01-24',
          col2: '2021-05-14',
          col3: '기술팀2',
          col4: '2021-06-24 hazop xx작업내용에 대한 개선요청',
          col5: '요청',
        },
        {
          col11: '현장확인',
          col12: '14-04 사업장 내·외부 PSM 관련 안전·보건 교육훈련계획을 승인하고 그 결과를 보고 받는가?',
          col13: '개선요청제목3',
          col1: '안전환경팀/시스템/2021-06-24',
          col2: '2021-07-24',
          col3: '기술팀',
          col4: '2021-06-24 hazop xx작업내용에 대한 개선요청',
          col5: '검토',
        },
      ];
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.popupOptions.title = '개선';
      this.popupOptions.param = {
        disabled: this.param.disabled,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  }
};
</script>